import React, { useEffect } from "react";
import Layout from "../../Global/Layout";

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page when component mounts
  }, []);
  return (
    <Layout>
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 py-16">
          <div className="bg-white rounded-2xl shadow-xl p-8 w-full">
            <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Terms & Conditions
            </h1>

            <p className="text-sm text-gray-600 mb-4">
              Last Date of Revision: 02/06/2024
            </p>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                General Terms
              </h2>
              <p className="text-gray-700 mb-4">
                We do not provide any financial return in any form whatsoever,
                including but not limited to financial securities (debt or
                equity), interest, dividend, profit share, or rewards in cash,
                to individuals who contribute on Donate Great.com.
              </p>
              <p className="text-gray-700">
                Any contribution on Donate Great.com, by an individual, should
                not be construed as an investment in any form whatsoever.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                Terms of Use
              </h2>
              <p className="text-gray-700 mb-4">
                This document is an electronic record in terms of the
                Information Technology Act, 2000, and rules thereunder as
                applicable, and the amended provisions pertaining to electronic
                records in various statutes as amended by the Information
                Technology Act, 2000.
              </p>
              <p className="text-gray-700">
                You are solely responsible for utilizing the funds for the
                Purpose mentioned on our fundraising page. Donate Great is not
                responsible in any way whatsoever towards the end utilization of
                funds.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                Refund Policy
              </h2>
              <p className="text-gray-700 mb-4">
                At Donate Great, we deeply value the trust our donors place in
                us and are committed to ensuring that all contributions are used
                effectively to support our campaigns. As a donation-raising
                platform, we operate with the principle that all donations are
                final and cannot be refunded. However, we understand that
                exceptional circumstances may arise, and we have outlined
                specific conditions under which refunds may be considered:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>
                  Fraudulent Campaigns: If it is determined that a campaign is
                  fraudulent or misleading, we will initiate a thorough
                  investigation. Donors will be eligible for a refund if the
                  campaign is confirmed to be fraudulent.
                </li>
                <li>
                  Unauthorized Donations: If a donation is made without the
                  donor's authorization, the donor must contact us immediately.
                  We will investigate the claim and process a refund if the
                  unauthorized transaction is verified.
                </li>
                <li>
                  Excess Payments: If the owner of a campaign receives excess
                  payments that cannot be utilized for the intended purpose, the
                  campaign owner may request a refund for the excess amount.
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                Third-Party Links and Resources Disclaimer
              </h2>
              <p className="text-gray-700 mb-4">
                The services provided by Donate Great may include, or third
                parties may offer, links and access to various sites, services,
                and resources available on the internet. Donate Great does not
                have any control over these external sites, services, and
                resources and does not endorse or assume responsibility for
                them.
              </p>
              <p className="text-gray-700">
                By using Donate Great's services, you agree to these terms and
                understand that your interactions with third-party sites and
                resources are at your own risk.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                Disclaimer of Warranties
              </h2>
              <p className="text-gray-700">
                YOU USE THE SERVICE AT YOUR OWN RISK. THE SERVICE IS PROVIDED
                "AS IS" AND "AS AVAILABLE." Donate Great AND ITS AFFILIATES
                SPECIFICALLY DISCLAIM ANY AND ALL WARRANTIES, WHETHER EXPRESS,
                IMPLIED, OR STATUTORY, INCLUDING, BUT NOT LIMITED TO, IMPLIED
                WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                TITLE, AND NON-INFRINGEMENT.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                Intellectual Property Rights
              </h2>
              <p className="text-gray-700 mb-4">
                Users retain ownership of any intellectual property rights that
                they hold in the content they upload, submit, or display on
                Donate Great. By posting content on our platform, users grant
                Donate Great a non-exclusive, royalty-free, transferable,
                sub-licensable, worldwide license to use, reproduce, modify,
                adapt, publish, translate, create derivative works from,
                distribute, and display such content.
              </p>
              <p className="text-gray-700">
                If you believe that your work has been used in a way that
                constitutes copyright infringement, please provide Donate Great
                with a written notice containing all necessary details.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                Arbitration Agreement
              </h2>
              <p className="text-gray-700 mb-4">
                By using the services provided by Donate Great, you agree that
                any dispute, claim, or controversy arising out of or relating to
                these terms and conditions shall be settled by arbitration in
                accordance with the provisions of the Arbitration and
                Conciliation Act, 1996 (India).
              </p>
              <p className="text-gray-700">
                You also waive any right to a jury trial in connection with any
                arbitration or litigation arising out of or related to these
                terms and conditions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                Privacy Policy and Communication Consent
              </h2>
              <p className="text-gray-700">
                By using the Services, you consent to our collection and use of
                personal data as outlined in our Privacy Policy. Additionally,
                you willingly grant Donate Great permission to contact you via
                various communication modes.
              </p>
            </section>

            <p className="text-gray-700 text-sm mt-8">
              By using our services, you acknowledge that you have read,
              understood, and agree to these Terms and Conditions.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TermsAndConditions;
